import { PublicKey } from '@solana/web3.js';

/** @group Constants */
export const WRAPPED_SOL_MINT = new PublicKey(
  'So11111111111111111111111111111111111111112'
);
